//@flow
import {
    shareViaPinterest,
    shareViaEmail,
    shareViaFacebook,
    shareViaTwitter,
    mailMessages,
    getSharePath,
    logError,
} from '../../helpers';
import { trackEvent } from '../../shared/helpers/tracking';
import { defineMessages } from 'react-intl';

import type { intlShape } from 'react-intl';

const messages = defineMessages({
    bodyText: {
        id: 'abt.designProfile.header.contact.emailBody',
        defaultMessage: 'Check out these projects by {firmName} on 1stdibs.',
    },
    pinterest: {
        id: 'abt.designProfile.header.contact.pinterestLabel',
        defaultMessage: 'See more work by {firmName} on 1stdibs',
    },
    twitter: {
        id: 'abt.designProfile.header.contact.twitterText',
        defaultMessage: 'Get to know the beautiful work of {firmName} on 1stdibs.',
    },
});

type Inputs = {|
    firmName: ?string,
    photoPath: ?string,
    urlLabel: ?string,
|};

export const SHARE_PINTEREST: 'pinterest' = 'pinterest';
export const SHARE_EMAIL: 'envelope' = 'envelope';
export const SHARE_FACEBOOK: 'facebook' = 'facebook';
export const SHARE_TWITTER: 'twitter' = 'twitter';

export type ShareTypes =
    | typeof SHARE_PINTEREST
    | typeof SHARE_EMAIL
    | typeof SHARE_FACEBOOK
    | typeof SHARE_TWITTER;

export const handleShare = (
    shareType: ShareTypes,
    { firmName, photoPath, urlLabel }: Inputs,
    intl: intlShape
) => {
    if (!urlLabel) {
        logError('Cannot share without a urlLabel');
        return;
    }

    const url = getSharePath(`/design-firms/${urlLabel}`);

    let category = 'share';
    let action = 'trade firm profile';
    let label;

    if (shareType === SHARE_PINTEREST) {
        if (!photoPath) {
            logError('Cannot share to Pinterest without a profile photo');
            return;
        }
        label = SHARE_PINTEREST;
        shareViaPinterest({
            url,
            description: intl.formatMessage(messages.pinterest, { firmName }),
            photoPath,
        });
    } else if (shareType === SHARE_EMAIL) {
        if (!firmName) {
            logError('Cannot send via email without a firm name');
            return;
        }
        category = 'email a friend';
        action = 'email a friend initiated';
        shareViaEmail({
            subject: intl.formatMessage(mailMessages.subject),
            body: intl.formatMessage(messages.bodyText, {
                firmName,
            }),
            url,
        });
    } else if (shareType === SHARE_FACEBOOK) {
        label = SHARE_FACEBOOK;
        shareViaFacebook(photoPath);
    } else if (shareType === SHARE_TWITTER) {
        const description = intl.formatMessage(messages.twitter, { firmName });
        label = SHARE_TWITTER;
        shareViaTwitter(description, url);
    }

    trackEvent({
        category,
        action,
        label,
    });
};
